import { useRef } from 'react'
import styles from './TopDLMM.module.scss'
import Button from 'components/common/Button/Button'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const TopDLMM: React.FC = () => {
  const leftRef = useRef<HTMLDivElement>(null)
  const isLeftVisible = useElementVisible(leftRef, 0.1)

  const rightRef = useRef<HTMLDivElement>(null)
  const isRightVisible = useElementVisible(rightRef, 0.1)

  return (
    <section className={styles.topDLMM}>
      <div className={styles.inner}>
        <div className={styles.container}>
          <article
            className={`${styles.dlmm} ${styles.download} ${animationStyles.fade} ${
              isLeftVisible ? animationStyles.fadeOn : ''
            }`}
            ref={leftRef}
          >
            <h2 className={styles.dlmm__title}>資料ダウンロード</h2>
            <p className={styles.dlmm__text}>
              私たちのノウハウや業界別の事例など、提供するサービスについて詳細にまとめた資料になります。
              <br className={styles.none} />
              ぜひご一読ください。
            </p>
            <div className={styles.dlmm__btn}>
              <Button text="資料一覧を見る" href="/download/" />
            </div>
            <ul className={styles.dlmm__items}>
              <li className={styles.dlmm__items__item}>
                <a href="/download/ai-ux-sprint/" className={styles.dlmm__items__item__link}>
                  <figure className={styles.dlmm__items__item__link__fig}>
                    <img
                      src="/images/img/download/ai-ux-sprint/thumbnail_ai_ux_sprint.webp"
                      alt="AI-UXスプリントサービス紹介資料"
                      width={380}
                      height={256}
                    />
                  </figure>
                  <p className={styles.dlmm__items__item__link__text}>AI-UXスプリントサービス紹介資料</p>
                </a>
              </li>
              <li className={styles.dlmm__items__item}>
                <a href="/download/rfp/" className={styles.dlmm__items__item__link}>
                  <figure className={styles.dlmm__items__item__link__fig}>
                    <img
                      src="/images/img/download/rfp/thumbnail_rfp.webp"
                      alt="開発ベンダーの真価を引き出すアプリ開発RFP作成のポイント"
                      width={380}
                      height={256}
                    />
                  </figure>
                  <p className={styles.dlmm__items__item__link__text}>
                    開発ベンダーの真価を引き出すアプリ開発RFP作成のポイント
                  </p>
                </a>
              </li>
            </ul>
          </article>
          <article
            className={`${styles.dlmm} ${styles.mailmagazine} ${animationStyles.fade} ${
              isRightVisible ? animationStyles.fadeOn3 : ''
            }`}
            ref={rightRef}
          >
            <h2 className={styles.dlmm__title}>メールマガジン</h2>
            <p className={styles.dlmm__text}>お役立ちメソッドや、限定イベントや最新事例などをお届けします。</p>
            <div className={styles.dlmm__btn}>
              <Button text="メールマガジンを登録" href="/mailmagazine/" />
            </div>
            <ul className={styles.dlmm__items}>
              <li className={styles.dlmm__items__item}>
                <a href="/mailmagazine/" className={styles.dlmm__items__item__link}>
                  <figure className={styles.dlmm__items__item__link__fig}>
                    <img src="/img/common/thumbnail_mailmagazine.webp" alt="メールマガジン" width={280} height={256} />
                  </figure>
                </a>
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  )
}

export default TopDLMM
